define('mapboxProvider/mapboxProvider',[], function() {
    'use strict';

    var mapboxgl = tryToGetMapbox();

    function tryToGetMapbox() {
        try {
            return require('mapbox-gl-js');
        } catch (e) {
             //hack to have optional dependency of mapboxgl
            return null;
        }
    }

    return {
        setMapbox: function(mapboxReference) {
            if (mapboxReference && mapboxReference.version !== '0.29.0') {
                console.warn('TomTom JS SDK expects mapboxgl "0.29.0" version.');
            }
            mapboxgl = mapboxReference;
        },
        tryToSetMapbox: function() {
            if (!this.isMapboxSet()) {
                mapboxgl = tryToGetMapbox();
            }
            return this.isMapboxSet();
        },
        getMapbox: function() {
            if (!this.isMapboxSet()) {
                throw new Error('You should provide Mapbox GL JS reference first.');
            }
            return mapboxgl;
        },
        isMapboxSet: function() {
            return Boolean(mapboxgl);
        },
        isMapboxSupported: function() {
            return this.tryToSetMapbox() && mapboxgl.supported();
        }
    };
});

